export default __webpack_public_path__ + "static/media/icon_people.7245299b.svg";